import { render, staticRenderFns } from "./EditNewsButton.vue?vue&type=template&id=49dc4c6c&"
import script from "./EditNewsButton.vue?vue&type=script&lang=js&"
export * from "./EditNewsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports